// Mock data for Jocker and Quinn Salon
import haircut from "./assets/images/haircut.jpg";
import haircolor from "./assets/images/haircolor.jpg";

import keratin from "./assets/images/keratin.jpg";
import hairspa from "./assets/images/hairspa.jpg";
import bridal from "./assets/images/bridal.jpg";
import smoothening from "./assets/images/smoothening.jpg";
import thickhair from "./assets/images/thickhair.jpg";
import shorthair from "./assets/images/shorthair.jpg";
import redhead from "./assets/images/redhead.jpeg";

import g1 from "./assets/images/g1.jpg";
import g2 from "./assets/images/g2.jpg";
import g3 from "./assets/images/g3.jpeg";
import g4 from "./assets/images/g4.jpeg";
import g5 from "./assets/images/g5.jpg";
import g6 from "./assets/images/g6.jpg";

export const salonInfo = {
  name: "JOKER & QUINN",
  tagline: "HAIRDRESSING",
  description: "Experience the finest unisex beauty services at Joker & Quinn. Expert stylists, premium treatments, and exceptional care await you.",
  phone: "+91 98840 22956",
  email: "jokerandquinnsalon@gmail.com"
};

export const services = [
  {
    id: 1,
    title: "Hair Cut",
    image: haircut,
    description: "A JOKER & QUINN cut is always special. Our highly trained staff will design a custom appearance using characteristic cutting techniques to complement your uniqueness, lifestyle, and hair structure."
  },
  {
    id: 2,
    title: "Hair Colour",
    image: haircolor,
    description: "Before developing the ideal colour for you, we provide professional consultation and heed to all your color needs while analyzing your skin tone, eye colour, and hair texture."
  },
  {
    id: 3,
    title: "Keratin Treatment",
    image: keratin,
    description: "A hair treatment that uses keratin to substantially improve the health, condition, and luster of unmanageable/frizzy hair."
  },
  {
    id: 4,
    title: "Hairspa Treatments",
    image: hairspa,
    description: "The JOKER & QUINN Hair Spa treatment leaves your hair and scalp incredibly clean and healthy while also relaxing and enhancing your mood."
  },
  {
    id: 5,
    title: "Bridal Hair & Makeup",
    image: bridal,
    description: "Come visit one of our JOKER & QUINN specialists for a consultation and trial to ensure that everything is flawless on your extra-special wedding day."
  },
  {
    id: 6,
    title: "Hair Smoothening",
    image: smoothening,
    description: "Our Hair smoothing treatments smoothen naturally frizzy hair but doesn't alter the structure of the hair drastically. Instead it removes frizz and dryness, and smoothes out your hair that lasts up to 6 months or more."
  }
];

export const priceTiers = [
  {
    id: 1,
    title: "Style Director",
    description: "Consultation, shampoo and condition with scalp massage, cut, finish and style",
    price: "₹1800"
  },
  {
    id: 2,
    title: "Creative Director",
    description: "Pre-shave consultation, exfoliating facial scrub, soothing hot towels",
    price: "₹1500"
  },
  {
    id: 3,
    title: "Top Stylist",
    description: "Style consultation, beard maintenance, shaping, tidying and finishing",
    price: "₹1200"
  },
  {
    id: 4,
    title: "Senior Stylist",
    description: "Style consultation, beard maintenance, shaping, tidying and finishing",
    price: "₹900"
  },
  {
    id: 5,
    title: "Stylist",
    description: "Style consultation, beard maintenance, shaping, tidying and finishing",
    price: "₹800"
  },
  {
    id: 6,
    title: "Kid's Haircut",
    description: "Style consultation, beard maintenance, shaping, tidying and finishing",
    price: "₹700"
  },
  {
    id: 7,
    title: "Men's Styling",
    description: "Style consultation, beard maintenance, shaping, tidying and finishing",
    price: "₹400"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Akshaya N",
    date: "9. April, 2024",
    rating: 5,
    text: "Rahul did an excellent job on my hair. I took global hair colouring service and he did a perfect makeover to my hair and i loved it."
  },
  {
    id: 2,
    name: "Harish Natarajan",
    date: "9. April, 2024",
    rating: 5,
    text: "Another Joker & Quinn outlet living up to its brand name with professionalism, great service, and warmth in everything! Special mentions to Mr. Aship for his wonderful therapy skills."
  },
  {
    id: 3,
    name: "Anitha",
    date: "9. April, 2024",
    rating: 5,
    text: "Service was damn good !! Stylist Sajid service was really really good he was very very friendly he did wonderful job always, keep doing keep rocking"
  },
  {
    id: 4,
    name: "Bhavana Jain",
    date: "9. April, 2024",
    rating: 5,
    text: "Sam is the best. He did an amazing makeover to my hair and made me super comfortable and confident throughout this journey. Thank you"
  },
  {
    id: 5,
    name: "Ram",
    date: "6. April, 2024",
    rating: 5,
    text: "I have got best hair cut and dressing experience and best beard trim. Love to attend by Reshma stylist. I will definitely visit again."
  },
  {
    id: 6,
    name: "Priya Murugan",
    date: "6. April, 2024",
    rating: 5,
    text: "Visited for a facial and waxing. Ms. Sukmit had a thorough analysis of my skin and understood the requirement so well and gave me the absolute best of a service."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Low-Density vs Thick Hair: Tailored Care Tips from Stylists",
    image: thickhair,
    excerpt: "Introduction As far as haircare is concerned, there can be no standard size. Although hair density and thickness sometimes get confused...",
    date: "September 24, 2025"
  },
  {
    id: 2,
    title: "Why Men Should Visit a Hair Salon: Beauty Is Genderless",
    image: shorthair,
    excerpt: "With all things fresh this year, self-care and self-love is something that is on the hook. While self-care has many aspects...",
    date: "March 15, 2025"
  },
  {
    id: 3,
    title: "9 Tips to Choose the Best Hair Stylist",
    image: redhead,
    excerpt: "Consider the following when choosing a stylist: Perform profound research, Check online reviews, Examine the stylist's portfolio...",
    date: "February 23, 2025"
  }
];

export const galleryImages = [
  g1,
  g2,
  g3,
  g4,
  g5,
  g6
];
